import {
  ActorRole,
  ReleaseDealControlDocument,
} from '@/lib/graphql/generated/graphql';
import { trackEvent } from '@/lib/mixpanel';
import { editionModeState } from '@/states/edition-mode.state';
import { useMutation } from '@apollo/client/react';
import { useSetAtom } from 'jotai';

export function useReleaseDealControl(dealId: string) {
  const setEditionMode = useSetAtom(editionModeState);
  const [releaseDealControlMutation, { loading, error }] = useMutation(
    ReleaseDealControlDocument
  );

  const releaseDealControl = async () => {
    const result = await releaseDealControlMutation({
      variables: { dealId },
    });

    const response = result.data?.releaseDealControl;
    if (response?.__typename === 'DomainException') {
      throw new Error(response.code);
    }

    setEditionMode(ActorRole.Brand);
    trackEvent('DEAL_CONTROL_RELEASED', { dealId });
    return result;
  };

  return {
    releaseDealControl,
    loading,
    error,
  };
}
